function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  fill: "#222222",
  d: "M30.4 3.84h-28.8c-0.884 0-1.6 0.716-1.6 1.6v0 21.12c0 0.884 0.716 1.6 1.6 1.6v0h28.8c0.884 0 1.6-0.716 1.6-1.6v0-21.12c0-0.884-0.716-1.6-1.6-1.6v0zM1.28 25.971v-18.662l9.331 9.331zM2.189 26.88l9.331-9.331 4.032 4.032c0.116 0.117 0.277 0.189 0.454 0.189s0.338-0.072 0.454-0.189v0l4.019-4.032 9.331 9.331zM30.72 25.971l-9.331-9.331 9.331-9.331zM30.72 5.491l-14.72 14.72-14.72-14.72c-0.003-0.015-0.004-0.033-0.004-0.051 0-0.177 0.143-0.32 0.32-0.32 0.001 0 0.003 0 0.004 0h28.8c0.177 0 0.32 0.143 0.32 0.32v0z"
});

var SvgIosMail = function SvgIosMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIosMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ios_Mail.8f99e867.svg";
export { ForwardRef as ReactComponent };